import {Link, Text} from 'platform/foundation';

import {isNil} from 'ramda';

import {TestIdProps} from 'shared/web';

import type {SellerContact} from '../../../types/SellerContact';

interface SellerContactValueProps extends TestIdProps {
  contact: SellerContact;
}

export function SellerContactValue(props: SellerContactValueProps) {
  if (isNil(props.contact.href)) {
    return (
      <Text size="small" alternative data-testid={props['data-testid']}>
        {props.contact.label}
      </Text>
    );
  }

  return (
    <Link
      size="small"
      href={props.contact.href}
      title={props.contact.label}
      data-testid={props['data-testid']}
    />
  );
}
